import { request } from '../request';

const serviceApi = {
  /**
   * 查询服务订单列表
   */
  getServiceOrderList(params: GetServiceOrderListParams) {
    return request<GetServiceOrderListResponse[]>({
      path: '/pad/service/order/v2/get/service/order/list',
      query: params,
    });
  },
  /**
   * 查询服务订单详情
   */
  getServiceOrder(orderId: string) {
    return request<GetServiceOrderListResponse>({
      path: '/pad/service/order/v2/get/service/order',
      query: { orderId },
    });
  },
  /**
   * 查询服务订单详情
   */
  getServiceOrderDetail(serviceOrderId: string) {
    return request<GetServiceOrderDetailResponse>({
      path: '/pad/service/order/v1/order/result',
      query: { serviceOrderId },
    });
  },
  /**
   * 获取正在进行中的服务订单
   */
  getServingOrder(customerId: number, config?: { ignoreErrHandler: boolean }) {
    return request<GetServingOrderResponse>({
      path: '/pad/service/order/v2/get/serving/order',
      query: { customerId },
    });
  },
  /**
   * 获取正在进行中的服务订单，根据按摩师查询
   */
  getServingOrderByOperator() {
    return request<GetServingOrderByOperatorResponse>({
      path: '/pad/service/order/v2/get/serving/order/by/operator',
    });
  },
  /**
   * 获取全部按摩方案
   */
  getAllProducts() {
    return request<GetAllProductsResponse[]>({ path: '/pad/goods/v2/list' });
  },
  /**
   * 获取指定 ID 的按摩方案
   */
  getProduct(storeGoodsId: number) {
    return request<GetProductResponse>({
      path: '/pad/goods/v2/get',
      query: { storeGoodsId },
    });
  },
  /**
   * 新建服务V3版本
   */
  createServiceOrder(params: CreateServiceOrderV4Params) {
    return request<CreateServiceOrderResponse>({
      path: '/pad/service/order/v4/create/service/order',
      method: 'POST',
      data: params,
      config: {
        ignoreErrorMessage: true,
      },
    });
  },
  /**
   * 获取门店剩余额度
   */
  getStoreRemainingQuota() {
    return request<StoreRemainingQuotaInfo>({
      path: '/pad/store/quota/v1/get',
    });
  },
  /**
   * 人工结束服务
   */
  terminatingOrder(orderId: string) {
    return request<never>({
      path: '/pad/service/order/v1/terminating/order',
      query: { orderId },
    });
  },
  /**
   * 获取服务订单中的设备信息
   */
  getServedDevices(serviceOrderId: string) {
    return request<GetServedDevicesResponse>({
      path: '/pad/service/order/v1/get/served/devices',
      query: { serviceOrderId },
    });
  },
  /**
   * 异常终止订单
   */
  interrupt(params: ServiceOrderInterruptParams) {
    return request<never>({
      path: '/pad/service/order/v1/interrupt/order',
      query: params,
    });
  },
  /**
   * 获取来着微信的订单
   */
  getOrderFromWx() {
    return request<GetOrderFromWxResponse>({
      path: '/pad/service/order/v2/get/order/from/wx',
    });
  },
  /**
   * 获取已创建的订单
   */
  getCreatedWxOrder() {
    return request<GetOrderFromWxResponse>({
      path: '/pad/service/order/v2/get/created/wx/order',
    });
  },
  /**
   * 核销订单
   */
  verifyWxOrder(params: VerifyWxOrderParams) {
    return request<{ servieOrderId: string }>({
      path: '/pad/service/order/v1/verify/wx/order',
      query: params,
    });
  },
  /**
   * 核销订单
   */
  startServing(params: StartServingParams) {
    return request<string>({
      path: '/pad/service/order/v1/begin/serving',
      query: params,
      config: {
        ignoreErrorMessage: true,
      },
    });
  },
  /**
   * 获取当前订单的用户引导
   */
  getUserGuide() {
    return request<GetUserGuideResponse | null>({
      path: '/pad/service/order/v1/get/user/guide',
    });
  },
  /**
   * 用户已读引导信息
   */
  readUserGuide() {
    return request<null>({
      path: '/pad/service/order/v1/read/user/guide',
    });
  },
  /**
   * 查询今日最后一个异常订单
   */
  getLastAbnormalOrder() {
    return request<GetLastAbnormalOrderResponse>({
      path: '/pad/service/order/v1/get/last/abnormal',
    });
  },
  /**
   * 获取上报信息
   */
  getReportInfo(serviceOrderId?: string) {
    return request<GetReportInfoResponse>({
      path: '/pad/abnormal/order/v1/get/report/info',
      query: { serviceOrderId },
    });
  },
  /**
   * 上报问题
   */
  reportAbnormalIssue(params: ReportAbnormalParams) {
    return request<boolean>({
      path: '/pad/abnormal/order/v1/save',
      method: 'POST',
      data: params,
    });
  },
  /**
   * 获取结束订单列表
   */
  getFinishedOrderList(params: GetFinishedOrderListParams) {
    return request<GetFinishedOrderListResponse[]>({
      path: '/pad/service/order/v1/list/end/order',
      method: 'POST',
      data: params,
    });
  },
  /**
   * 获取结束订单列表
   */
  getAbnormalOrderList(params: GetAbnormalOrderListParams) {
    return request<GetAbnormalOrderListResponse>({
      path: '/pad/abnormal/order/v1/page',
      method: 'POST',
      data: params,
    });
  },
  /**
   * 检查商品是否有效
   */
  checkStoreGoods(storeGoodsId: number) {
    return request<boolean>({
      path: '/pad/service/order/v1/check/storeGoods',
      query: { storeGoodsId },
    });
  },

  /**
   * pad获取新的引导图 操作流程图
   */
  getUserGuideInfo(orderId: string) {
    return request<GetUserGuideInfoResponse>({
      path: '/pad/service/order/v2/get/user/guide',
      query: { orderId },
    });
  },
};

export default serviceApi;
